import Icon from '../components/Icon.vue'

Icon.register({"caret-square-up":{"width":448,"height":512,"paths":[{"d":"M0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432zM355.5 291.5L232.5 168.5C227.8 163.8 220.2 163.8 215.5 168.5L92.5 291.5C84.9 299.1 90.3 312 101 312H347C357.7 312 363.1 299.1 355.5 291.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/caret-square-up.js
// module id = null
// module chunks = 